import { render, staticRenderFns } from "./CheckoutProductDetails.vue?vue&type=template&id=177f6c9b&scoped=true"
import script from "./CheckoutProductDetails.vue?vue&type=script&lang=js"
export * from "./CheckoutProductDetails.vue?vue&type=script&lang=js"
import style0 from "./CheckoutProductDetails.vue?vue&type=style&index=0&id=177f6c9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f6c9b",
  null
  
)

export default component.exports